import { render, staticRenderFns } from "./base-player.vue?vue&type=template&id=1ca55ce8&scoped=true&"
import script from "./base-player.vue?vue&type=script&lang=js&"
export * from "./base-player.vue?vue&type=script&lang=js&"
import style0 from "./base-player.vue?vue&type=style&index=0&id=1ca55ce8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca55ce8",
  null
  
)

export default component.exports